import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { VaultManagementComponent } from '@app/authorized/vault-management/vault-management.component';
import { VaultItemComponent } from '@app/authorized/vault-management/vault-item/vault-item.component';
import { DbmAdditionalOptionsModule } from '@app/shared/components/dbm-components/dbm-additional-options/dbm-additional-options.module';
import { VaultConnectionService } from '@src/services/VaultConnectionService.service';
import { Utils } from '@src/utils/util';

@NgModule({
    imports: [SharedModule, DbmAdditionalOptionsModule],
    declarations: [
        VaultItemComponent,
        VaultManagementComponent
    ],
    providers: [VaultConnectionService, Utils],
    entryComponents: [VaultManagementComponent],
    exports: [VaultManagementComponent]
})
export class VaultManagementModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/vault-management/vault-management.module.ts